///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class GameScreen extends BaseScreen {

        private gameplay:nscs.gameplay.Gameplay;

        bg:Phaser.GameObjects.Container;
        fg:Phaser.GameObjects.Container;

        gridRenderView:Phaser.GameObjects.Container;
        gridRender:Phaser.GameObjects.Container;
        spritesTopLayer:Phaser.GameObjects.Container;
        spritesBackLayer:Phaser.GameObjects.Container;
        player:nscs.character.Player;

        inGameUI:InGameUI;

        worldIdName:string;

        ladderArray:Phaser.Physics.Arcade.Sprite[];

        playerToGridCollider: Phaser.Physics.Arcade.Collider;

        constructor(scene:Phaser.Scene, worldIdName:string) {
            super(scene);

            this.gameplay = nscs.scene.MainScene.instance.gameplay;
            this.worldIdName = worldIdName;

            this.synchronizeGravity();

            this.inGameUI = new InGameUI(this.scene);
            this.inGameUI.setScrollFactor(0);

            // set background
            this.bg = new Phaser.GameObjects.Container(this.scene, 0,0);
            this.add(this.bg);
            for (var i:number = 0; i<2; i++) {
                let img = new Phaser.GameObjects.Image(this.scene, i*(730-1), 0, "bg-atlas", this.gameplay.levelData['bg']+'_bg' + '0000').setOrigin(0, 0);
                this.bg.add(img);
            }
            this.fg = new Phaser.GameObjects.Container(this.scene, 0,0);
            this.add(this.fg);
            for (var i:number = 0; i<4; i++) {
                let img = new Phaser.GameObjects.Image(this.scene, i*(730-1), 0, "bgfg-atlas", this.gameplay.levelData["bg"]+'_fg' + '0000').setOrigin(0, 0);
                this.fg.add(img);
            }

            this.bg.setScrollFactor(0);
            this.fg.setScrollFactor(0);

            //tiles
            this.repaintGrid();

            this.spritesBackLayer = this.scene.add.container(0, 0);
            this.add(this.spritesBackLayer);

            this.player  = new nscs.character.Player();
            this.player.setWorldPosition(this.gameplay.newX, this.gameplay.newY);
            this.add(this.player.sprite);

            this.playerToGridCollider = this.scene.physics.add.collider(this.gridRender.getAll(), this.player.sprite, (o1, o2)=>{
                this.onContactWithStaticObject(o1 == this.player.sprite ? o2 : o1);
            });

            this.spritesTopLayer = this.scene.add.container(0, 0);
            this.add(this.spritesTopLayer);

            this.add(this.inGameUI);
            this.inGameUI.setScrollFactor(0);
            this.inGameUI.pauseScreen.onResume = ()=>{
                this.setPaused(false);
            };
            this.inGameUI.pauseScreen.onQuit = ()=>{
                this.gameplay.destroyTimer();
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene)/*new nscs.screen.HigscoreScreen(this.scene)*/, false);
                nscs.sound.SoundManager.getInstance().stopMusic();
            };

            this.startFollowCamera();

            input.InputManager.instance.create(this.scene);

            this.scene.game.events.on('prerender', this.onPreRender, this);
        }

        public startFollowCamera():void {
            // set bounds so the camera won't go outside the game world
            this.scene.cameras.main.setBounds(0, 0, this.gameplay.worldWidth, this.gameplay.worldHeight);
            // make the camera follow the player
            this.scene.cameras.main.startFollow(this.player.sprite, true, 0.75, 0.75, 0, -40);
            this.scene.cameras.main.setRoundPixels(true);
        }
        public stopFollowCamera():void {
            // make the camera follow the player
            this.scene.cameras.main.stopFollow();
        }

        private shackleBirdContainer:Phaser.GameObjects.Container;
        private createShackleBirds():void {
            this.shackleBirdContainer = this.scene.add.container(1120, 1110);
            this.addAt(this.shackleBirdContainer, this.getIndex(this.gridRender));

            let anim:string = 'playing-shackleBirdFlappingMC';
            if (!this.scene.anims.exists(anim)) {
                this.scene.anims.create({
                    key: anim,
                    frames: this.scene.anims.generateFrameNames('boss-atlas', {
                        start: 0, end: 8, zeroPad: 4,
                        prefix: 'shackleBirdFlappingMC', suffix: ''
                    }),
                    frameRate: 30,
                    repeat: -1
                });
            }

            for (let i:number = 0; i < 6; i++) {
                let shackleBirdFlappingMC = this.scene.add.sprite(775, 100, 'boss-atlas', 'shackleBirdFlappingMC'+'0000');
                shackleBirdFlappingMC.setOrigin(0.5, 0);
                let fn = ()=>{
                    if (Math.random() > 0.75) {
                        shackleBirdFlappingMC.setFrame('shackleEmptyMC0000');
                    } else {
                        shackleBirdFlappingMC.anims.play(anim);
                    }
                };
                fn();
                this.shackleBirdContainer.add(shackleBirdFlappingMC);
                this.scene.tweens.add({
                    targets: shackleBirdFlappingMC,
                    x: -70,
                    duration: 10000,
                    delay: i * 1650,
                    repeat: -1,
                    onRepeat: fn
                });
            }
        }

        public onSpritesAdded():void {
            if (this.finishFlag) {
                this.finishFlag.visible = this.boss ? false : true;
            }
            if (this.boss) {
                this.createShackleBirds();
            }

            let gridSprites = this.gridRender.getAll();
            let sprites = this.getAllSprites();
            for (let s of sprites) {
                if (this.isSpriteGravityAllowed(s)) {
                    if (s.body) {
                        s.body["setAllowGravity"](true);
                        s.setCollideWorldBounds(true);

                        this.scene.physics.add.collider(gridSprites, s);

                        for (let b of sprites) {
                            if (b["spriteType"] == 'B') {
                                this.scene.physics.add.collider(b, s);
                            }
                        }
                    }
                }
            }
        }

        public addSprite(sprite:Phaser.GameObjects.Sprite|Phaser.GameObjects.Container):void {
            if (sprite["libId"] == "bossMC") {
                this.boss = sprite as nscs.character.Boss;
                this.boss.setup(
                    this.player,
                    1060,
                    1885,
                    this.boss.y,
                    this.boss.y + 115,
                    this.onRonaldKilled,
                    this.onBossAttacksPlayer
                );
                this.addAt(this.boss, this.getIndex(this.player.sprite));
                return;
            } else if (sprite["libId"] == "flagPoleMC") {
                this.finishFlag = sprite as Phaser.GameObjects.Container;
                (this.finishFlag["flagPoleMC"] as Phaser.Physics.Arcade.Sprite).body.checkCollision.up = (this.finishFlag["flagPoleMC"] as Phaser.Physics.Arcade.Sprite).body.checkCollision.down = false;
                this.addAt(this.finishFlag, this.getIndex(this.gridRender)+1);
                return;
            }

            let topLayerSprites:string[] = [
                'decor84MC', 'decor83MC', 'decor82MC', 'decor81MC', 'decor79MC', 'decor78MC', 'decor80MC', 'decor113MC', 'decor77MC',
                'decor76MC', 'decor13MC', 'decor12MC', 'decor15MC', 'decor17MC', 'decor16MC', 'decor100MC', 'decor69MC', 'decor68MC',
                'decor18MC', 'decor14MC', 'decor19MC', 'decor10MC', 'decor26MC', 'decor92MC', 'decor91MC'
            ];
            if (topLayerSprites.indexOf(sprite["libId"]) >= 0) {
                this.spritesTopLayer.add(sprite);
            } else {
                this.spritesBackLayer.add(sprite);
            }
        }

        private activeBubbles:Phaser.GameObjects.Image[] = [];
        public showBubbles(x:number, y:number, minNum:number, maxNum:number, direction:string, dBase:number, lifeDistance:number, duration:number, onComplete):void {
            let num:number = minNum + Math.round(Math.random() * Math.floor(maxNum - minNum));
            for (let i:number = 0; i < num; i++) {
                let fromX:number = x, fromY:number = y;
                if (direction == "left" || direction == "right") {
                    fromY += (Math.random()-0.5)*dBase;
                } else if (direction == "up" || direction == "down") {
                    fromX += (Math.random()-0.5)*dBase;
                }
                let toX:number = fromX, toY:number = fromY;
                if (direction == "left") {
                    toX -= lifeDistance;
                } else if (direction == "right") {
                    toX += lifeDistance;
                } else if (direction == "up") {
                    toY -= lifeDistance;
                } else if (direction == "down") {
                    toY += lifeDistance;
                }

                let bubble = new Phaser.GameObjects.Image(this.scene, fromX, fromY, 'objects-atlas', 'whiteBubbleMC'+'0000');
                bubble.setOrigin(0.5, 0.5);
                bubble.setScale(0.75 + Math.random() * 0.25);
                bubble['-onLifeEndCallback-'] = ()=>{
                    if (onComplete) onComplete();
                    if (bubble.parentContainer) bubble.parentContainer.remove(bubble);
                };
                this.scene.tweens.add({
                    targets: bubble,
                    x: toX,
                    y: toY,
                    scale: 0,
                    alpha: 0.5,
                    duration: duration,
                    ease:Phaser.Math.Easing.Sine.Out,
                    onComplete: bubble['-onLifeEndCallback-'],
                    onStart: ()=>{
                        bubble.visible = true;
                        this.activeBubbles.push(bubble);
                    },
                    delay: i * 50 + Math.random() * 100
                });
                bubble.visible = false;
                this.addAt(bubble, this.getIndex(this.spritesBackLayer)-1);
            }
        }

        private destroyBubble(b:Phaser.GameObjects.Image):void {
            let ind:number = this.activeBubbles.indexOf(b);
            if (ind >= 0) this.activeBubbles.splice(ind, 1);
            this.scene.tweens.killTweensOf(b);
            b['-onLifeEndCallback-']();
        }

        public showTextPopUp(content:string):void {
            let txt:Phaser.GameObjects.Text = this.scene.add.text(this.player.sprite.x, this.player.sprite.y, "", {
                "fontFamily": "AxaxaxRg-Bold",
                "fontSize": 12,
                "color": "#FFFFFF",
                "align": 'center'
            }).setOrigin(0.5, 0.5);
            txt.setStroke('#000000', 2);
            this.add(txt);
            nscs.util.Functions.updateTextFieldPosition(txt, content);

            this.scene.tweens.add({
                targets: txt,
                y: txt.y - 75,
                duration: 1000,
                onComplete: ()=>{
                    if (txt.parentContainer) txt.parentContainer.remove(txt);
                }
            });

            if (content == '1UP') {
                nscs.sound.SoundManager.getInstance().playSound('1upSND');
            }
        }

        public scoreUp(number:number):void {
            this.showTextPopUp(String(number));
        }

        public showPickUpHeart(x:number, y:number):void {
            let heart = new Phaser.GameObjects.Sprite(this.scene, x, y, 'objects-atlas', 'OneUpXMC'+'0000');
            this.scene.tweens.add({
                targets: heart,
                y: heart.y - 60,
                alpha: 0,
                duration: 1500,
                ease:Phaser.Math.Easing.Sine.Out,
                onComplete: ()=>{
                    if (heart.parentContainer) heart.parentContainer.remove(heart);
                }
            });
            this.addAt(heart, this.getIndex(this.spritesBackLayer) + 1);
        }

        public showPickUpChick(chick?, scaleX?:number, x?:number, y?:number):void {
            if (!chick) {
                chick = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC") as Phaser.GameObjects.Sprite;
                chick.setPosition(x, y);
                chick.scaleX = scaleX;
            }
            this.scene.tweens.add({
                targets: chick,
                x: chick.x + (chick.scaleX > 0 ? 1 : -1) * (Math.random()*35+40),
                y: chick.y - 200 - Math.random()*20,
                duration: 2500 + Math.random()*750,
                ease:Phaser.Math.Easing.Sine.Out,
                onComplete: ()=>{
                    if (chick.parentContainer) chick.parentContainer.remove(chick);
                }
            });
            this.scene.tweens.add({
                targets: chick,
                delay: 1000,
                duration: 500,
                alpha: 0
            });
            this.addAt(chick, this.getIndex(this.spritesBackLayer) + 1);
        }

        public repaintGrid():void {
            this.ladderArray = [];

            this.gridRender = this.scene.add.container(0, 0);
            this.add(this.gridRender);
            this.gridRenderView = this.scene.add.container(0, 0);
            this.add(this.gridRenderView);

            let noPhysics:object[] = [
                [0,0],[12,12],[10,15],[14,12],[1,0],[10,0],[11,11],[14,11],[8,11],[8,12],[8,13],[9,12],[9,11],[10,11],[11,11],[10,12],[10,6],[11,6],
                [1,9],[2,9],[9,13],[3,11]
            ];

            let _grid:number[][] = [];

            const n:number = 16;
            for (var i = 0; i< this.gameplay.worldTilesY; i++) {

                let _row:Array<number> = new Array<number>(this.gameplay.worldTilesX);
                for (let _i = 0; _i < this.gameplay.worldTilesY; _i++) _row[_i] = 0;
                _grid.push(_row);

                for (var j=0; j< this.gameplay.worldTilesX; j++) {
                    if (this.gameplay.grid[i][j]>0) {
                        var srcx:number = this.gameplay.grid[i][j]%n;
                        var srcy:number = Math.floor(this.gameplay.grid[i][j]/n);

                        let cdw:number = 0;
                        let cdh:number = 0;
                        if (srcx == 10 && srcy == 0) cdw = -1;
                        else if (srcx== 11&&srcy==2 || srcx== 12&&srcy==2 || srcx== 13&&srcy==2) cdh = -1;

                        if (Number(this.gameplay.ladder_array[this.gameplay.grid[i][j]]) == 1) {
                            let ladder_tile = this.scene.physics.add.sprite( j*this.gameplay.tileWidth, i*this.gameplay.tileHeight,'texture');
                            ladder_tile.setOrigin(srcx/(n-1), srcy/(n-1));
                            ladder_tile.setCrop(srcx*this.gameplay.tileWidth, srcy*this.gameplay.tileHeight, this.gameplay.tileWidth + cdw, this.gameplay.tileHeight + cdh);
                            ladder_tile.setCollideWorldBounds(false);
                            ladder_tile.body.setSize(this.gameplay.tileWidth, this.gameplay.tileHeight);
                            ladder_tile.setImmovable(true);
                            ladder_tile.body["setAllowGravity"](false);
                            ladder_tile.body.setOffset(srcx/(n-1)*ladder_tile.width, srcy/(n-1)*ladder_tile.height);
                            this.ladderArray.push(ladder_tile);
                            this.add(ladder_tile);
                            ladder_tile["-grid-i-"] = i;
                            ladder_tile["-grid-j-"] = j;
                        } else {
                            let hasNoPhysics:boolean = false;
                            for (let np of noPhysics) if (srcx == np[0] && srcy == np[1]) {
                                hasNoPhysics = true;
                                break;
                            }
                            if (!hasNoPhysics) {
                                _row[j] = 1;
                            }

                            let tile = this.scene.add.sprite( j*this.gameplay.tileWidth, i*this.gameplay.tileHeight,'texture');
                            tile.setOrigin(srcx/(n-1), srcy/(n-1));
                            tile.setCrop(srcx*this.gameplay.tileWidth, srcy*this.gameplay.tileHeight, this.gameplay.tileWidth + cdw, this.gameplay.tileHeight + cdh);
                            this.gridRenderView.add(tile);
                        }
                    }
                }
            }

            this.createGridRenderPhysics(_grid);
        }

        private isTileInBlockRects(i, j, rects):boolean {
            for (let r of rects) {
                if (i >= r["i"] && j >= r["j"] && i < r["i"] + r["h"] && j < r["j"] + r["w"]) {
                    return true;
                }
            }
            return false;
        }

        private createGridRenderPhysics(_grid:number[][]):void {
            let rects = [];

            for (let i:number = 0; i < _grid.length; i++) {
                label_1:for (let j:number = 0; j < _grid[i].length; j++) {
                    let w:number = 0;
                    let h:number = 0;
                    if (_grid[i][j] == 1) {
                        if (this.isTileInBlockRects(i, j, rects)) {
                            continue label_1;
                        }

                        w = 1;
                        h = 1;
                        for (let k:number = i+1; k < _grid.length; k++) {
                            if (this.isTileInBlockRects(k, j, rects)) {
                                break;
                            }
                            if (_grid[k][j] != 1) break; else h++;
                        }
                        label:for (let l:number = j+1; l < _grid[i].length; l++) {
                            for (let k:number = i; k < i+h; k++) {
                                if (this.isTileInBlockRects(k, l, rects)) {
                                    break label;
                                }
                                if (_grid[k][l] != 1) break label;
                            }
                            w++;
                        }
                        rects.push({
                            "i":i, "j":j, "w":w, "h":h
                        });
                    }
                }
            }

            for (let r of rects) {
                let tile = this.scene.physics.add.sprite( r["j"]*this.gameplay.tileWidth + (r["w"]-1)*this.gameplay.tileWidth/2, r["i"]*this.gameplay.tileHeight+(r["h"]-1)*this.gameplay.tileHeight/2, null);
                tile.setCollideWorldBounds(false);
                tile.setOrigin(0);
                tile.visible = false;
                tile.body.setSize(r["w"]*this.gameplay.tileWidth, r["h"]*this.gameplay.tileHeight);
                tile.setImmovable(true);
                tile.body["setAllowGravity"](false);
                this.gridRender.add(tile);
            }
        }

        private updateBlock(sprite_mc:Phaser.Physics.Arcade.Sprite):void {
            this.scene.physics.world.collide(this.player.sprite, sprite_mc, ()=>{
                this.onContactWithStaticObject(sprite_mc);

                if (sprite_mc["displayType"] && sprite_mc["displayType"].toLowerCase().indexOf("solid") >= 0) return;

                //------------------------------------
                let crash:()=>void = ()=>{
                    let bblock1BreakMC:Phaser.GameObjects.Sprite = this.scene.add.sprite(sprite_mc.x, sprite_mc.y, 'objects-atlas', 'bblock1BreakMC'+'0000');
                    bblock1BreakMC.setOrigin(0.5, 1);
                    this.addAt(bblock1BreakMC, this.getIndex(this.spritesBackLayer) + 1);

                    let anim:string = 'bblock1BreakMC' + "_" + "playingAnimName";
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(bblock1BreakMC.texture.key, {
                                start: 0, end: 11, zeroPad: 4,
                                prefix: 'bblock1BreakMC', suffix: ''
                            }),
                            frameRate: 60
                        });
                    }
                    bblock1BreakMC.anims.play(anim);
                    bblock1BreakMC.once('animationcomplete', ()=>{if(bblock1BreakMC.parentContainer)bblock1BreakMC.parentContainer.remove(bblock1BreakMC);});

                    nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc as Phaser.Physics.Arcade.Sprite, sprite_mc["displayType"] = 'makeSolid');

                    if (sprite_mc.parentContainer) sprite_mc.parentContainer.remove(sprite_mc);
                    nscs.sound.SoundManager.getInstance().playSound('breakBlockSND');
                };
                //------------------------------------

                if (
                    this.gameplay.isGravityFlipped() ?
                        ((this.player.sprite.body.touching.down && sprite_mc.body.touching.up)
                            ||
                            (this.player.sprite.body.touching.up && sprite_mc.body.touching.down && this.player.pounceLanding)) :
                        ((this.player.sprite.body.touching.up && sprite_mc.body.touching.down)
                            ||
                            (this.player.sprite.body.touching.down && sprite_mc.body.touching.up && this.player.pounceLanding))

                ) {
                    if (sprite_mc["displayType"] == "question" || sprite_mc["displayType"] == "masked") {
                        //------------------------------------
                        if (sprite_mc["playLabel"] == "chick") {
                            nscs.scene.MainScene.instance.gameplay.addChick();
                            this.showPickUpChick(null,Math.random() > 0.5 ? 1 : -1, sprite_mc.x, sprite_mc.y);
                        } else if (sprite_mc["playLabel"] == "tofu" || (sprite_mc["playLabel"] == "1up" && (!isNaN(sprite_mc["points"])) && sprite_mc["points"] != 0)) {
                            this.createTofuMC(sprite_mc.x, sprite_mc.y - 15, sprite_mc["playLabel"]);
                        } else if (sprite_mc["playLabel"] == "1up") {
                            this.gameplay.addLife();
                            this.showPickUpHeart(sprite_mc.x, sprite_mc.y - 20);
                        } else if (sprite_mc["playLabel"] == "seakitten") {
                            this.createSeakitten(sprite_mc.x, sprite_mc.y - 20);
                        }
                        //------------------------------------
                        if (!isNaN(sprite_mc["points"]) && sprite_mc["points"] > 0) {
                            this.gameplay.scoreUp(sprite_mc["points"]);
                        }
                        //------------------------------------
                        sprite_mc["hitsLeft"]--;
                        if (sprite_mc["hitsLeft"] <= 0) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc as Phaser.Physics.Arcade.Sprite, sprite_mc["displayType"] = 'makeSolid');
                        } else {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc as Phaser.Physics.Arcade.Sprite, 'question-wobble');
                            nscs.sound.SoundManager.getInstance().playSound('bumpSND');
                        }
                    } else if (typeof sprite_mc["displayType"] === "undefined") {
                        if (this.gameplay.charSize == "small") {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc as Phaser.Physics.Arcade.Sprite, 'wobble');
                            nscs.sound.SoundManager.getInstance().playSound('bumpSND');
                        } else if (this.gameplay.charSize == "big") {
                            // this.player.sprite.setVelocityY(0);
                            crash();
                        }
                    } else if (sprite_mc["displayType"] === "hidden") {
                        if (sprite_mc["hitsLeft"] == 0) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc as Phaser.Physics.Arcade.Sprite, sprite_mc["displayType"] = 'hiddenToSolid');
                        } else {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc as Phaser.Physics.Arcade.Sprite, sprite_mc["displayType"] = 'question');
                        }
                    }


                    // console.log(sprite_mc["hitsLeft"],sprite_mc["playLabel"],sprite_mc["points"], sprite_mc["displayType"])
                }

            });
        }

        private tofuMCs = [];
        private createTofuMC(x:number, y:number, playLabel:string):void {
            let tofuMC:Phaser.Physics.Arcade.Sprite = this.scene.physics.add.sprite(x, y, 'objects-atlas', 'tofuMC' + '0000');
            tofuMC.setOrigin(0, 1);
            tofuMC.setCollideWorldBounds(false);
            tofuMC.setImmovable(true);
            tofuMC.body["setAllowGravity"](false);
            tofuMC.alpha = 0;
            tofuMC.scaleY = 0;
            this.scene.tweens.add({
                targets: tofuMC,
                duration: 500,
                alpha:1,
                scaleY:1,
                onComplete: ()=>{
                    tofuMC['-activated-'] = true;
                }
            });
            tofuMC["playLabel"] = playLabel;
            this.addAt(tofuMC, this.getIndex(this.spritesBackLayer)+1);
            this.tofuMCs.push(tofuMC);

            nscs.sound.SoundManager.getInstance().playSound('tofuSND');
        }

        private seakittens = [];
        private createSeakitten(x:number, y:number):void {
            let seakitten:Phaser.Physics.Arcade.Sprite = this.scene.physics.add.sprite(x, y, 'objects-atlas', 'skMC' + '0000');
            seakitten.setOrigin(0, 1);
            seakitten.setCollideWorldBounds(false);
            seakitten.setImmovable(true);
            seakitten.body["setAllowGravity"](false);
            seakitten.alpha = 0;
            seakitten.scaleY = 0;
            this.scene.tweens.add({
                targets: seakitten,
                duration: 500,
                alpha:1,
                scaleY:1,
                onComplete: ()=>{
                    seakitten['-activated-'] = true;
                }
            });

            this.addAt(seakitten, this.getIndex(this.spritesBackLayer)+1);
            this.seakittens.push(seakitten);

            nscs.sound.SoundManager.getInstance().playSound('seaKittenSND');
        }

        private updateTofu():void {
            for (let i = this.tofuMCs.length - 1; i >= 0; i--) {
                let tofuMC = this.tofuMCs[i];
                if (!tofuMC['-activated-']) continue;

                this.scene.physics.world.overlap(this.player.sprite, tofuMC, ()=>{
                    if (tofuMC["playLabel"] == "1up") {
                        this.gameplay.addLife();
                    } else {
                        this.gameplay.scoreUp(1000);
                        this.player.setCharSize("big");
                        nscs.sound.SoundManager.getInstance().playSound('growBigSND');
                    }

                    this.scene.tweens.add({
                        targets: tofuMC,
                        duration: 500,
                        alpha:0,
                        scaleY: 0,
                        onComplete:()=>{
                            if (tofuMC.parentContiner) tofuMC.parentContiner.remove(tofuMC);
                        }
                    });
                    this.tofuMCs.splice(i, 1);
                });
            }
        }

        private updateSeakitten():void {
            for (let i = this.seakittens.length - 1; i >= 0; i--) {
                let seakitten = this.seakittens[i];
                if (!seakitten['-activated-']) continue;

                this.scene.physics.world.overlap(this.player.sprite, seakitten, ()=>{
                    this.gameplay.scoreUp(1000);
                    this.player.setCharSize("big");
                    this.player.setSeaKittenise(true);

                    nscs.sound.SoundManager.getInstance().playSound('growBigSND');

                    this.scene.tweens.add({
                        targets: seakitten,
                        duration: 500,
                        alpha:0,
                        scaleY: 0,
                        onComplete:()=>{
                            if (seakitten.parentContiner) seakitten.parentContiner.remove(seakitten);
                        }
                    });
                    this.seakittens.splice(i, 1);
                });
            }
        }

        public updateChick(sprite_mc):void {
            this.scene.physics.world.overlap(this.player.sprite, sprite_mc, ()=>{
                nscs.scene.MainScene.instance.gameplay.addChick();
                if (sprite_mc.parentContainer) sprite_mc.parentContainer.remove(sprite_mc);
                this.showPickUpChick(sprite_mc);

                nscs.sound.SoundManager.getInstance().playSound('coinSND');
            });
        }

        public onEnemyOrHazzardContacted():void {
            if (this.player.fullyActive()) {
                if (this.gameplay.charSize == "big") {
                    this.player.setCharSize("small");
                    nscs.sound.SoundManager.getInstance().playSound('shrinkSND');
                    this.player.setImmortalBlinking();
                } else {
                    this.minusOneLife();
                }
            }
        }

        public updateHazzard(sprite_mc:Phaser.Physics.Arcade.Sprite):void {
            if (this.player.immortalBlinkingTicker != 0) return;
            this.scene.physics.world.collide(this.player.sprite, sprite_mc, ()=>{
                this.onEnemyOrHazzardContacted();
                nscs.sound.SoundManager.getInstance().playSound('spikesSND');
            });
        }


        private recentEnemyKillsNumber:number = 0;
        private recentEnemyKillsNumberDelayedCall = null;
        public gainScoreForEnemyKill(): void {
            if (this.recentEnemyKillsNumberDelayedCall) nscs.util.Functions.destroyDelayedCall(this.recentEnemyKillsNumberDelayedCall);
            this.recentEnemyKillsNumberDelayedCall = nscs.util.Functions.delayedCall(1750, ()=>{this.recentEnemyKillsNumber = 0;});
            this.recentEnemyKillsNumber++;
            this.gameplay.scoreUp(this.player.pounceLanding ? this.recentEnemyKillsNumber * 750 : this.recentEnemyKillsNumber * 500)
        }

        private enemy4MCArray = [];

        private updateEnemy4MC():void {
            let sprite_mc:Phaser.Physics.Arcade.Sprite;
            for (sprite_mc of this.enemy4MCArray) {
                if (sprite_mc["dead"]) continue;

                if (this.gameplay.isGravityFlipped()) {
                    sprite_mc.body["setAllowGravity"](false);
                }/* else {
                    sprite_mc.body["setAllowGravity"](true);
                }*/

                if (sprite_mc.body.velocity.y < 0 && sprite_mc.body.velocity.y > -10) {
                    sprite_mc.setVelocityY(-50);
                }

                let d:number = Phaser.Math.Distance.Between(this.player.sprite.x, this.player.getFootsWorldY(), sprite_mc.x, sprite_mc.y);

                let ch = this.gridRender.getAll();
                for (let c of ch) {
                    this.scene.physics.world.collide(sprite_mc, c, ()=>{
                        if (sprite_mc.body.touching.right || sprite_mc.body.touching.left) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'bounceSide');
                            if (d < 250) nscs.sound.SoundManager.getInstance().playSound('fryKidSND');
                        } else if (
                            this.gameplay.isGravityFlipped() ?
                                sprite_mc.body.touching.down || sprite_mc.body.touching.up :
                                sprite_mc.body.touching.up || sprite_mc.body.touching.down
                        ) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'bounce');
                            if (d < 250) nscs.sound.SoundManager.getInstance().playSound('fryKidSND');
                        }
                    });
                }
            }
        }

        public showDustMC(x:number, y:number, scale:number, angle:number):void {
            let dustMC:Phaser.GameObjects.Sprite = this.scene.add.sprite(x, y, 'objects-atlas', 'dustMC' + '0000');
            dustMC.setOrigin(0.5, 0.75);
            let anim:string = 'dustMC' + "_" + "playingAnimName";
            if (!this.scene.anims.exists(anim)) {
                this.scene.anims.create({
                    key: anim,
                    frames: this.scene.anims.generateFrameNames(dustMC.texture.key, {
                        start: 0, end: 39, zeroPad: 4,
                        prefix: 'dustMC', suffix: ''
                    }),
                    frameRate: 60
                });
            }
            dustMC.play(anim);
            dustMC.once('animationcomplete', ()=>{if (dustMC.parentContainer) dustMC.parentContainer.remove(dustMC);})
            dustMC.setScale(scale);
            dustMC.setAngle(angle);
            this.addAt(dustMC, this.getIndex(this.player.sprite)+1);
        }

        public updateEnemy(sprite_mc:Phaser.Physics.Arcade.Sprite):void {
            if (sprite_mc["dead"]) return;

            let hitTestMethod:string = "collide";

            if (sprite_mc["libId"] == "enemy3MC") {
                if (nscs.scene.MainScene.instance.factory.isAnimationComplete(sprite_mc)) {
                    nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, Math.random() > 0.9 ? 'attack' : 'idle');
                }
            } else if (sprite_mc["libId"] == "enemy5MC") {
                let dist:number = Phaser.Math.Distance.Between(sprite_mc.x, sprite_mc.y, this.player.sprite.x, this.player.sprite.y);
                if (!sprite_mc["appeared"]) {
                    if (dist < 250) {
                        sprite_mc["appeared"] = true;
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'appear');
                        nscs.sound.SoundManager.getInstance().playSound('mbJumpSND');
                        nscs.sound.SoundManager.getInstance().playSound('mbRustleSND');
                    }
                } else {
                    if (dist > 250) {
                        sprite_mc["appeared"] = false;
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'disappear');
                    }
                    if (nscs.scene.MainScene.instance.factory.isAnimationComplete(sprite_mc)) {
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, Math.random() > 0.85 ? 'attack' : 'appeared');
                    }
                }
            } else if (sprite_mc["libId"].indexOf("enemy4MC") == 0) {
                hitTestMethod = "overlap";
                if (Math.abs(this.player.sprite.x - sprite_mc.x) < game.scale.width && Math.abs(this.player.sprite.y - sprite_mc.y) < game.scale.height) {
                    if (this.enemy4MCArray.indexOf(sprite_mc) < 0) {
                        this.enemy4MCArray.push(sprite_mc);

                        sprite_mc.setVelocity((Math.random()>0.5?1:-1)*(Math.random()*0.5 + 0.5) * 40, (Math.random()*0.5 + 0.5) * 100);
                        sprite_mc.setBounce(1, 1);
                        sprite_mc.setCollideWorldBounds(false);
                        sprite_mc.setImmovable(false);
                        sprite_mc.body["setAllowGravity"](true);

                        sprite_mc['-defVelocityLength-'] = sprite_mc.body.velocity.length();

                        this.scene.tweens.add({
                            targets: sprite_mc,
                            angle: Math.random()>0.5?360:-360,
                            duration: 5000,
                            repeat: -1,
                            ease: Phaser.Math.Easing.Linear
                        });
                    }
                }
            }

            if (sprite_mc["libId"] == "enemy5MC" && !sprite_mc["appeared"]) {
                return;
            }

            this.scene.physics.world[hitTestMethod](this.player.sprite, sprite_mc, ()=>{
                // sprite_mc.setImmovable(true);
                // sprite_mc.body["setAllowGravity"](false);
                sprite_mc.setVelocity(0, sprite_mc.body.velocity.y);

                if (this.gameplay.isGravityFlipped() ? this.player.sprite.body.touching.up : this.player.sprite.body.touching.down) {
                    if (this.gameplay.isGravityFlipped() ? sprite_mc.body.touching.down : sprite_mc.body.touching.up) {
                        if (this.player.pounceLanding) {
                            sprite_mc["hitsToKill"] = 0;
                        } else {
                            sprite_mc["hitsToKill"]--;
                        }
                        if (sprite_mc["hitsToKill"] == 0) {
                            sprite_mc["dead"] = true;
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'die');
                            this.gainScoreForEnemyKill();
                            nscs.sound.SoundManager.getInstance().playSound('squashSND');
                            nscs.sound.SoundManager.getInstance().playSound('hairballHitSND');
                        } else {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'hit');
                        }

                        this.player.doAfterJumpOverEnemy();
                    }
                }
                if (!sprite_mc["dead"]) {
                    if (this.player.sprite.body.touching.left || this.player.sprite.body.touching.right || this.player.sprite.body.touching.up) {
                        if (
                            sprite_mc.body.touching.left || sprite_mc.body.touching.right || (this.gameplay.isGravityFlipped() ? sprite_mc.body.touching.up : sprite_mc.body.touching.down)
                        ) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'attack');
                            this.onEnemyOrHazzardContacted();
                        }
                    }
                }
            });

            if (sprite_mc.y > this.gameplay.waterLevel) {
                if (!sprite_mc['tickerModer']) sprite_mc['tickerModer'] = Math.ceil(Math.random() * 10) + 30;
                if (this.ticker % sprite_mc['tickerModer'] == 0 && Math.random() > 0.75) {
                    this.showBubbles(
                        sprite_mc.x,
                        sprite_mc.y,
                        1,
                        2,
                        this.gameplay.isGravityFlipped() ? 'down' : 'up',
                        10,
                        75 + Math.random() * 50,
                        1500,
                        null
                    );
                }
            }
        }

        private isSpriteGravityAllowed(sprite_mc):boolean {
            return sprite_mc["libId"] == "decor93MC" || sprite_mc["libId"] == "decor94MC" || sprite_mc["libId"] == "decor95MC" || sprite_mc["libId"] == "enemy3MC";
        }

        public updateDecor(sprite_mc):void {
            if (sprite_mc["libId"] == 'decor96MC' && this.gameplay.inWater) {
                let dx:number = this.player.sprite.x - sprite_mc.x;
                let dy:number = this.player.sprite.y - sprite_mc.y;
                let d:number = Math.sqrt(dx * dx + dy * dy);
                sprite_mc.scaleY = this.player.sprite.x < sprite_mc.x ? -1 : 1;
                sprite_mc.rotation = Math.atan2(dy, dx);
                let sprite_mcY:number = sprite_mc.y;
                if (d < 300 && d > 75) {
                    sprite_mc.x += (this.player.sprite.x - sprite_mc.x) / 60;
                    sprite_mcY += (this.player.sprite.y - sprite_mcY) / 60;
                }

                if (sprite_mc.y > this.gameplay.waterLevel) {
                    if (this.ticker % 45 == 0 && Math.random() > 0.5) {
                        this.showBubbles(
                            sprite_mc.x,
                            sprite_mc.y,
                            1,
                            3,
                            this.gameplay.isGravityFlipped() ? 'down' : 'up',
                            10,
                            75 + Math.random() * 50,
                            1000,
                            null
                        );
                    }
                }

                if (this.isPointInWater(sprite_mc.x, sprite_mcY - 20)) {
                    sprite_mc.y = sprite_mcY;
                }
            }

            if (!sprite_mc["decorType"]) return;

            if (sprite_mc["decorType"]=='protestor' && sprite_mc["speech"]) {
                if (!sprite_mc['exlamationXMC-created']) {
                    sprite_mc['exlamationXMC-created'] = true;
                    let exlamationXMC = new Phaser.GameObjects.Image(this.scene,0, 0,
                        'decor-atlas', 'exlamationXMC'+'0000');
                    let updatePosition = ()=>{
                        exlamationXMC.setPosition(
                            sprite_mc.x + sprite_mc.scaleX * 20,
                            sprite_mc.y + (0.5 - sprite_mc.originY) * sprite_mc.height + (13) * (this.gameplay.gravityDir)
                        );
                        exlamationXMC.flipY = this.gameplay.isGravityFlipped();
                    };
                    updatePosition();
                    sprite_mc['exlamationXMC'] = exlamationXMC;
                    exlamationXMC.setOrigin(0, 1);
                    this.addAt(exlamationXMC, this.getIndex(this.spritesBackLayer) + 1);
                    exlamationXMC.scale = 0;
                    this.scene.tweens.add({
                        targets: exlamationXMC,
                        duration: 1000,
                        scale: 1.5,
                        repeat: -1,
                        onUpdate:()=>{
                            sprite_mc['exlamationXMC'].scaleX = (sprite_mc.scaleX > 0?1:-1)*sprite_mc['exlamationXMC'].scaleX;
                            updatePosition();
                        }
                    });
                    this.scene.tweens.add({
                        targets: exlamationXMC,
                        duration: 1000,
                        alpha: 0,
                        repeat: -1,
                        ease: Phaser.Math.Easing.Expo.In
                    });
                }

                let scaleX:number = 1;
                if (sprite_mc.hasOwnProperty('lookingLeft')) scaleX = sprite_mc['lookingLeft'] ? 1 : -1;
                if (!this.isSpriteGravityAllowed(sprite_mc)) {
                    if (this.player.sprite.x < sprite_mc.x) {
                        scaleX *= 1;
                    } else {
                        scaleX *= -1;
                    }
                }
                sprite_mc.scaleX = scaleX;

                let overlap:boolean = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                if (overlap) {
                    if (!sprite_mc["speaking"]) {
                        sprite_mc["speaking"] = true;
                        this.inGameUI.showSpeechDialog(this.scene.cameras.main.getScroll(sprite_mc.x, sprite_mc.y).x, nscs.gameplay.Gameplay.getText('activist'+sprite_mc["speech"]));
                        nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                    } else {
                        this.inGameUI.updateSpeechDialog(this.scene.cameras.main.getScroll(this.player.sprite.x, this.player.sprite.y).x);
                    }
                } else {
                    if (sprite_mc["speaking"]) {
                        sprite_mc["speaking"] = false;
                        this.inGameUI.hideSpeechDialog();
                    }
                }
            } else if (sprite_mc["decorType"].indexOf('pipe')==0) {
                let overlap:boolean = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                if (overlap) {
                    this.onContactWithStaticObject(sprite_mc);

                    let inputController:nscs.input.InputController = nscs.scene.MainScene.instance.inputController;
                    let l:boolean = (inputController.cursorKeys.left.isDown || input.InputManager.instance.isDown('LEFT'))
                        && sprite_mc.body.touching.right && this.player.sprite.body.touching.left;
                    let r:boolean = (inputController.cursorKeys.right.isDown || input.InputManager.instance.isDown('RIGHT'))
                        && sprite_mc.body.touching.left && this.player.sprite.body.touching.right;
                    if (
                        (sprite_mc["decorType"]=='pipeDown' && (
                            this.gameplay.isGravityFlipped() ?
                                    /*inputController.cursorKeys.up.isDown && */sprite_mc.body.touching.down && this.player.sprite.body.touching.up :
                                (inputController.cursorKeys.down.isDown || input.InputManager.instance.isDown('DOWN'))
                                && sprite_mc.body.touching.up && this.player.sprite.body.touching.down
                            ))
                        ||
                        (sprite_mc["decorType"]=='pipeUp' && (
                            this.gameplay.isGravityFlipped() ?
                                (inputController.cursorKeys.down.isDown || input.InputManager.instance.isDown('DOWN'))
                                && sprite_mc.body.touching.up && this.player.sprite.body.touching.down :
                                /*inputController.cursorKeys.up.isDown && */sprite_mc.body.touching.down && this.player.sprite.body.touching.up
                        ))
                        ||
                        (
                            sprite_mc["decorType"]=='pipeSide' && (l || r)
                        )
                    ) {
                        let inDirection:string;
                        if (sprite_mc["decorType"]=='pipeDown') inDirection = 'down';
                        else if (sprite_mc["decorType"]=='pipeUp') inDirection = 'up';
                        else if (l) inDirection = 'left';
                        else if (r) inDirection = 'right';

                        this.pipeTravel(sprite_mc["pipeRoute"], inDirection);
                    }
                }
            } else if (sprite_mc["decorType"]=='bounce' || sprite_mc["decorType"]=='uberBounce') {
                let overlap:boolean = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                if (overlap) {
                    this.player.doBounceJump();
                    nscs.scene.MainScene.instance.factory.playAnimation(sprite_mc);
                    nscs.sound.SoundManager.getInstance().playSound('bouncerSND');
                }
            } else if (sprite_mc["decorType"]=='recovery') {
                if (!sprite_mc['-active-']) {
                    if (this.scene.physics.world.overlap(this.player.sprite, sprite_mc)) {
                        sprite_mc['-active-'] = true;
                    }
                }
            } else if (sprite_mc["decorType"]=='switch') {
                if (sprite_mc["switchType"] == "gravity") {
                    if (this.player.pounceLanding) {
                        sprite_mc.body.checkCollision.right = sprite_mc.body.checkCollision.left = false;
                        if (this.scene.physics.world.collide(this.player.sprite, sprite_mc)) {
                            if (this.gameplay.isGravityFlipped() ?
                                this.player.sprite.body.touching.up && sprite_mc.body.touching.down :
                                this.player.sprite.body.touching.down && sprite_mc.body.touching.up
                            ) {
                                this.shceduleGravitySwitching = true;
                                this.onContactWithStaticObject(sprite_mc);
                            }
                        }
                    }
                }
            } else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0,3)=='fan') {
                if (this.scene.physics.world.overlap(this.player.sprite, sprite_mc)) {
                    if (sprite_mc["decorType"]=='fanUp') {
                        this.player.fanUp = true;
                    } else {
                        if (sprite_mc["decorType"]=='fanLeft') {
                            this.player.fanLeft = true;
                        } else if (sprite_mc["decorType"]=='fanRight') {
                            this.player.fanRight = true;
                        }
                    }
                }

                //bubbles
                let startX:number = sprite_mc.x;
                let startY:number = sprite_mc.y;
                if (sprite_mc["decorType"]=='fanUp') {
                    startX += 50;
                    startY += 5;
                } else if (sprite_mc["decorType"]=='fanLeft') {
                    startX += 5;
                    startY += 55;
                } else if (sprite_mc["decorType"]=='fanRight') {
                    startX += 75;
                    startY += 55;
                }
                if (!sprite_mc.hasOwnProperty('-activeBubbles-')) {
                    sprite_mc['-activeBubbles-'] = 0;
                }
                if (!sprite_mc.hasOwnProperty('-ticker-')) {
                    sprite_mc['-ticker-'] = 0;
                }
                if (sprite_mc['-ticker-'] == 0) {
                    if (sprite_mc['-activeBubbles-'] < 5) {
                        let directionMap:object = {
                            'fanUp':'up',
                            'fanLeft':'left',
                            'fanRight':'right'
                        };
                        let num:number = 1 + Math.round(Math.random() * Math.floor(3 - 1));
                        sprite_mc['-activeBubbles-'] += num;
                        this.showBubbles(
                            startX,
                            startY,
                            num,
                            num,
                            directionMap[sprite_mc["decorType"]],
                            50,
                            150 + Math.random()*50,
                            750,
                            ()=>{
                                sprite_mc['-activeBubbles-']--;
                        });
                    }
                }
                sprite_mc['-ticker-']++;
                sprite_mc['-ticker-'] %= 10;
            }
        }

        private shceduleGravitySwitching:boolean = false;

        public synchronizeGravity():void {
            this.scene.physics.world.gravity.set(0, this.gameplay.calculateGravity());
        }

        public switchGravity():void {
            this.gameplay.gravityDir *= -1;
            this.synchronizeGravity();

            this.player.updateBodyFlipY();
            this.player.updateBodyOffset();
            this.player.playForcedFlyAnimation();

            let sprites = this.getAllSprites();
            for (let sprite_mc of sprites) {
                if (this.isSpriteGravityAllowed(sprite_mc)) {
                    sprite_mc.setImmovable(false);
                    if(this.gameplay.isGravityFlipped()){
                        sprite_mc.flipY = true;
                        sprite_mc.body.offset.y = sprite_mc.body.offset['-yFlipped-'];
                    } else {
                        sprite_mc.flipY = false;
                        sprite_mc.body.offset.y = sprite_mc.body.offset['-y-'];
                    }
                }
            }

            this.showWhiteSplashScreen();

            nscs.sound.SoundManager.getInstance().playSound('gravitySND');
        }

        private isPipeTravelingActive:boolean = false;
        public pipeTravel(pipeRoute:string, inDirection:string) {
            if (this.isPipeTravelingActive) return;
            // init
            var newWorldId:string = null;
            var enterAniAxis:string = 'down';
            var newX = 0;
            var newY = 0;

            switch(pipeRoute) {
                ////////////////// LEVEL 1 PIPES ///////////////////
                // shortcut
                case '1-1':
                    newX = 1316;
                    newY = 287;
                    enterAniAxis = 'left';
                    break;
                // shortcut
                case '1-2':
                    newX = 2175;
                    newY = 1231;
                    enterAniAxis = 'down';
                    break;
                // shortcut
                case '1-3':
                    newX = 2239;
                    newY = 206;
                    enterAniAxis = 'down';
                    break;
                ////////////////// LEVEL 2 PIPES ///////////////////
                // shortcut
                case '2-1':
                    newX = 608;
                    newY = 431;
                    enterAniAxis = 'down';
                    break;
                // shortcut
                case '2-2':
                    newX = 545;
                    newY = 1407;
                    enterAniAxis = 'up';
                    break;
                // to part 2 of level 2
                case '2-3':
                    newWorldId = '2.1';
                    newX = 99;
                    newY = 846;
                    enterAniAxis = 'down';
                    break;
                // to part 3 of level 2
                case '2-4':
                    newWorldId = '2.2';
                    newX = 1244;
                    newY = 1275;
                    enterAniAxis = 'right';
                    break;
                /////////////////////////// LEVEL 3 PIPES ///////////////////////////
                // shortcut
                case '3-1':
                    newX = 735;
                    newY = 687;
                    enterAniAxis = 'down';
                    break;
                // shortcut
                case '3-2':
                    newX = 255;
                    newY = 639;
                    enterAniAxis = 'up';
                    break;
                /////////////////////////// LEVEL 4 PIPES ////////////////////////////
                // level 4 hidden level
                case '4-1':
                    newWorldId = '4.1';
                    newX = 1370;
                    newY = 176;
                    enterAniAxis = 'down';
                    break;
                // hidden level shortcut
                case '4-2':
                    newX = 1376;
                    newY = 718;
                    enterAniAxis = 'down';
                    break;
                // return to level 4 from hidden level
                case '4-3':
                    newWorldId = '4';
                    newX = 1535;
                    newY = 1214;
                    enterAniAxis = 'up';
                    break;
                // level 5 shortcut
                case '5-1':
                    newX = 383;
                    newY = 687;
                    enterAniAxis = 'down';
                    break;
                // level 5 hidden level ###
                case '5-2':
                    newX = 2143;
                    newY = 623;
                    enterAniAxis = 'down';
                    break;
                // to final boss level
                case '5-3':
                    newX = 1214;
                    newY = 847;
                    newWorldId = '5.1';
                    enterAniAxis = 'down';
                    break;
            }

            let doNotResetTimerFlag = true;

            // accomodate for height difference:
            if (enterAniAxis=='down' && newY) newY += 16;

            let dSize:number = this.gameplay.charSize == 'small' ? 35 : 40;
            if (enterAniAxis == "left") newX += dSize;
            else if (enterAniAxis == "right") newX -= dSize;

            this.player.goInOutPipe(inDirection, dSize, ()=>{
                this.showBlackFGFading(()=>{
                    if (newWorldId) {
                        nscs.scene.MainScene.instance.gameplay.loadWorld(newWorldId, false, false, true);

                        let newGameScreen:GameScreen = nscs.scene.MainScene.instance.gameplay.gameScreen;
                        newGameScreen.player.setWorldPosition(newX, newY);
                        newGameScreen.isPipeTravelingActive = true;
                        newGameScreen.player.goInOutPipe(enterAniAxis, dSize,()=>{
                            newGameScreen.isPipeTravelingActive = false;
                            newGameScreen.player.resetPipeGoing();
                        });

                        this.isPipeTravelingActive = false;
                    } else {
                        this.player.setWorldPosition(newX, newY);
                        this.isPipeTravelingActive = true;
                        this.player.goInOutPipe(enterAniAxis, dSize,()=>{
                            this.isPipeTravelingActive = false;
                        });

                        this.player.resetPipeGoing();
                    }
                });
            });

            nscs.sound.SoundManager.getInstance().playSound('pipeSND');
        }

        private recoverySprites:Array<any>;
        public fetchRecoveryPoints():void {
            this.recoverySprites = [];
            let ch = this.getAllSprites();
            for (let c of ch) {
                if (c["decorType"] == 'recovery') {
                    this.recoverySprites.push(c);
                }
            }
        }

        public findClosestActiveRecoveryPoint():object {
            let minDist:number = Number.MAX_VALUE;
            let closest = {x:this.gameplay.newX, y:this.gameplay.newY};
            for (let r of this.recoverySprites) {
                if (r['-active-']) {
                    let d:number = Phaser.Math.Distance.Between(this.player.sprite.x, this.player.sprite.y, r.x, r.y);
                    if (d < minDist) {
                        minDist = d;
                        closest = r;
                    }
                }
            }
            return closest;
        }

        private reusedArray:Array<any> = [];
        private getAllSprites():Array<any> {
            this.reusedArray.splice(0, this.reusedArray.length);
            this.reusedArray = this.reusedArray.concat(this.spritesBackLayer.getAll()).concat(this.spritesTopLayer.getAll());
            return this.reusedArray;
        }

        private boss:nscs.character.Boss = null;

        public onRonaldKilled:()=>void = ()=> {
            if (!this.finishFlag) return;
            this.finishFlag.visible = true;
            nscs.scene.MainScene.instance.factory.playAnimation(this.finishFlag, "boss-flag-appear");
            nscs.sound.SoundManager.getInstance().playSound('flagGrowSND');
        };
        public onBossAttacksPlayer:()=>void = ()=> {
            this.onEnemyOrHazzardContacted();
        };

        public onFlagReached():void {
            if (this.isFlagReached) return;

            nscs.scene.MainScene.instance.factory.playAnimation(this.finishFlag, this.boss ? "boss-flag-reached" : "normal-flag-reached");
            nscs.sound.SoundManager.getInstance().playSound('flagHitSND');

            this.player.isFlagReached = true;
            this.isFlagReached = true;

            this.gameplay.calculateTotalScore();
            this.inGameUI.tweenScore(this.gameplay.score,3000);
            this.inGameUI.tweenTimer(0,3000);

            this.gameplay.destroyTimer();

            nscs.util.Functions.delayedCall(4000, ()=>{
                nscs.scene.MainScene.instance.proceedLevelComplete();
            });

            nscs.sound.SoundManager.getInstance().playSound('levelCompleteSND');
        }

        private isFlagReached:boolean = false;
        private finishFlag:Phaser.GameObjects.Container = null;
        private checkFlagReached():void {
            if (!this.finishFlag) return;
            if (!this.finishFlag.visible) return;

            let collide:boolean = this.scene.physics.world.collide(this.player.sprite, this.finishFlag["flagPoleMC"]);
            if (collide) {
                this.onFlagReached();
            }
        }

        private updateSprites():void {
            let ch = this.getAllSprites();
            for (let sprite_mc of ch) {
                let spriteType:string = sprite_mc["spriteType"];
                if (spriteType == 'E') {
                    this.updateEnemy(sprite_mc as Phaser.Physics.Arcade.Sprite);
                }  else if (spriteType == 'H') {
                    this.updateHazzard(sprite_mc as Phaser.Physics.Arcade.Sprite);
                } else if (spriteType == 'C') {
                    this.updateChick(sprite_mc);
                }  else if (spriteType=='D') {
                    this.updateDecor(sprite_mc);
                } else if (spriteType == 'B') {
                    this.updateBlock(sprite_mc as Phaser.Physics.Arcade.Sprite);
                }
            }
        }

        public onContactWithStaticObject(staticObject):void {
            if (
                this.gameplay.isGravityFlipped() ?
                    this.player.sprite.body.touching.up && staticObject.body['touching'].down :
                    this.player.sprite.body.touching.down && staticObject.body['touching'].up
            ) {
                this.player.contactDownWithStaticObject = true;
            }
            if (this.player.sprite.body.touching.left && staticObject.body['touching'].right) {
                this.player.contactLeftWithStaticObject = true;
            }
            if (this.player.sprite.body.touching.right && staticObject.body['touching'].left) {
                this.player.contactRightWithStaticObject = true;
            }
        }

        private updateLadder():void {
            let inputController:nscs.input.InputController = nscs.scene.MainScene.instance.inputController;

            //ladder blocks
            let contactWithLadding:boolean = false;
            for (let l of this.ladderArray) {
                let i:number = l["-grid-i-"];
                let j:number = l["-grid-j-"];

                let overlaps:boolean = this.scene.physics.world.overlap(this.player.sprite, l);
                if (overlaps) {
                    if (i == 0 || Number(this.gameplay.ladder_array[this.gameplay.grid[i-1][j]]) != 1) {
                        if (
                            this.gameplay.isGravityFlipped() ?
                                this.player.sprite.body.touching.up && l.body['touching'].down && !(inputController.cursorKeys.up.isDown || input.InputManager.instance.isDown('UP')) :
                                this.player.sprite.body.touching.down && l.body['touching'].up && !(inputController.cursorKeys.down.isDown || input.InputManager.instance.isDown('DOWN'))
                        ) {
                            if (this.scene.physics.world.collide(this.player.sprite, l)) {
                                this.onContactWithStaticObject(l);
                            }
                        }
                    }
                    let dx:number = this.player.sprite.x - l['x'];
                    if (dx < 25 && dx > 9) {
                        contactWithLadding = true;
                    }
                }
            }
            if (contactWithLadding) {
                if (!this.player.isPlayerLadding) {
                    if ((inputController.cursorKeys.up.isDown || input.InputManager.instance.isDown('UP')) || (inputController.cursorKeys.down.isDown || input.InputManager.instance.isDown('DOWN'))) {
                        this.player.isPlayerLadding = true;
                    }
                }
            } else {
                this.player.isPlayerLadding = false;
            }
        }

        public showFallingCharacter(onComplete):void {
            this.gameplay.pause();

            this.remove(this.player.sprite, false);
            this.addAt(this.player.sprite, this.getIndex(this.spritesTopLayer) + 1);

            this.scene.tweens.add({
                targets: this.player.sprite,
                y: this.player.sprite.y - (this.gameplay.isGravityFlipped() ? 200 : 125),
                duration: 500,
                ease: Phaser.Math.Easing.Sine.Out,
                onComplete: ()=>{
                    let prevFlipY:boolean = this.player.sprite.flipY;
                    this.player.sprite.flipY = false;
                    this.scene.tweens.add({
                        targets: this.player.sprite,
                        y: this.player.sprite.y + game.scale.height,
                        duration: 750,
                        ease: Phaser.Math.Easing.Sine.In,
                        onComplete: ()=>{
                            this.player.sprite.flipY = prevFlipY;
                            onComplete();
                        }
                    });
                }
            });

            nscs.sound.SoundManager.getInstance().playSound('dyingSND');
        }

        public showGameOverScreen():void {
            this.gameplay.destroyTimer();
            let gos = new nscs.screen.GameOverScreen(this.scene);
            nscs.scene.MainScene.instance.switchScreen(gos, true);
            nscs.sound.SoundManager.getInstance().stopMusic();
            nscs.sound.SoundManager.getInstance().playSound('gameoverSND');
        }

        public onTimeout():void {
            this.inGameUI.timeover_mc.visible = true;
            this.player.setTempDead(true);
            this.stopFollowCamera();
            this.showFallingCharacter(()=>{
               this.showGameOverScreen();
            });
        }

        public tryMinusOneLife():void {
            if (this.player.fullyActive() && !this.isFlagReached) {
                this.minusOneLife();
            }
        }

        public showNewGameNewWorldScreen():void {
            this.inGameUI.showNewWorldScreen();
            nscs.util.Functions.delayedCall(2000, ()=>{
                this.showBlackFGFading(()=>{
                    this.inGameUI.hideNewWorldScreen();
                });
            });

            nscs.sound.SoundManager.getInstance().playSound('gamestartSND');
        }

        public minusOneLife():void {
            this.gameplay.minusLife();
            this.player.minusOneLife();

            let closest = this.findClosestActiveRecoveryPoint();

            this.stopFollowCamera();

            this.showFallingCharacter(()=>{
                if (this.gameplay.lives == 0) {
                    sendEvent(petaGA_GameCategory_Game, 'Die', 'New Super Chick Sisters - Die World ' + nscs.scene.MainScene.instance.getWorldNumber());

                    this.showGameOverScreen();
                } else {
                    this.inGameUI.showNewWorldScreen();
                    nscs.util.Functions.delayedCall(2000, ()=>this.showBlackFGFading(()=>{
                        this.remove(this.player.sprite, false);
                        this.addAt(this.player.sprite, this.getIndex(this.spritesTopLayer));

                        this.player.respawn(closest['x'], closest['y']);
                        this.startFollowCamera();
                        this.inGameUI.hideNewWorldScreen();
                        this.gameplay.resume();
                    }));
                }
            });
        }

        public showBlackFGFading(onMid):void {
            this.showFGFading(onMid, 250, 500, 0x000000);
        }

        public showWhiteSplashScreen():void {
            this.showFGFading(null, 40, 120, 0xFFFFFF);
        }

        public showFGFading(onMid, druationIn, durationOut, color):void {
            let transition = this.createShape(color);
            this.inGameUI.add(transition);

            transition.alpha = 0;
            this.scene.tweens.add({
                targets: transition,
                alpha: 1,
                duration: druationIn,
                ease: Phaser.Math.Easing.Linear,
                onComplete: ()=>{
                    if (onMid) onMid();

                    this.scene.tweens.add({
                        targets: transition,
                        alpha: 0,
                        duration: durationOut,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: ()=>{
                            this.inGameUI.remove(transition, true);
                        }
                    });
                }
            });
        }

        public onPreRender(renderer, time, delta):void {
            if (!this.parentContainer) return;
            this.player.updateSeaKitten();
        }

        public onRemovedFromParent():void {
            // this.stopFollowCamera();
            // this.playerToGridCollider.active = false;
        }

        public onAddedToParent():void {
            // this.playerToGridCollider.active = true;
            this.startFollowCamera();
            this.player.setup();
        }

        public destroy(fromScene?: boolean): void {
            this.scene.game.events.off('prerender', this.onPreRender, this);

            this.setPaused(false);

            if (this.shackleBirdContainer) {
                for (let s of this.shackleBirdContainer.getAll()) {
                    this.scene.tweens.killTweensOf(s);
                }
            }

            this.scene.cameras.resetAll();

            if (this.recentEnemyKillsNumberDelayedCall) {
                nscs.util.Functions.destroyDelayedCall(this.recentEnemyKillsNumberDelayedCall);
                this.recentEnemyKillsNumberDelayedCall = null;
            }

            super.destroy(fromScene);

            nscs.input.InputManager.instance.destroy();
        }

        private ticker:number = 0;

        private generatePlayerWaterBubbles():void {
            this.showBubbles(
                this.player.sprite.x,
                this.player.getFootsWorldY() - 5 * this.gameplay.gravityDir,
                1,
                4,
                this.gameplay.isGravityFlipped() ? 'down' : 'up',
                10,
                75 + Math.random() * 50,
                1000,
                null
            );
        }

        private updateBubbles():void {
            if (!this.gameplay.inWater) return;

            if (this.ticker % 15 == 0 && Math.random() > 0.6) {
                if (Math.abs(this.player.sprite.body.velocity.x) > Math.abs(this.gameplay.xSpeed) * 0.5 || Math.random() > 0.75) {
                    this.generatePlayerWaterBubbles();
                }
            }

            for (let i:number = this.activeBubbles.length - 1; i >= 0; i--) {
                if (!this.isPointInWater(this.activeBubbles[i].x, this.activeBubbles[i].y)) {
                    this.destroyBubble(this.activeBubbles[i]);
                }
            }
        }

        public updateBoss():void {
            if (!this.boss) return;

            this.boss.updateBoss();
        }

        private isPointInWater(x:number, y:number):boolean {
            let inWater:boolean = y > this.gameplay.waterLevel;

            if (this.gameplay.waterRects) {
                for (let r of this.gameplay.waterRects) {
                    if ((x > r['p1'].x && y > r['p1'].y) && (x < r['p2'].x && y > r['p2'].y)
                        &&
                        (x > r['p4'].x && y < r['p4'].y) && (x < r['p3'].x && y < r['p3'].y)
                    ) {
                        inWater = true;
                        break;
                    }
                }
            }

            return inWater;
        }

        private updateInWater():void {
            let prevInWater:boolean = this.gameplay.inWater;
            this.gameplay.inWater = this.isPointInWater(this.player.sprite.x, this.player.getFootsWorldY());

            if (prevInWater != this.gameplay.inWater) {
                this.gameplay.updateWaterPhysics();
                this.synchronizeGravity();

                if (this.gameplay.inWater) {
                    this.generatePlayerWaterBubbles();
                    nscs.sound.SoundManager.getInstance().playSound('splashdownSND');

                    this.player.sprite.body.velocity.y /= 5;
                } else {
                    this.player.sprite.body.velocity.y *= 2.2;
                }
            }
        }

        public updateScreen():void {
            super.updateScreen();

            this.updateEnemy4MC();

            if (this.player.tempDead) return;

            this.updateBG();

            this.ticker++;

            this.updateTofu();
            this.updateSeakitten();

            this.updateLadder();

            this.updateSprites();

            this.player.update();

            this.updateBoss();

            if (this.player.fallenBelowTheWorld) {
                this.tryMinusOneLife();
            }

            this.updateInWater();

            this.checkFlagReached();

            if (this.shceduleGravitySwitching) {
                this.shceduleGravitySwitching = false;
                this.switchGravity();
            }

            this.updateBubbles();

            this.updatePause();
        }

        private isPaused:boolean = false;
        public updatePause():void {
            let esc:boolean = nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased();
            if (esc) {
                this.setPaused(!this.isPaused);
                nscs.scene.MainScene.instance.inputController.escPressUsed();
            }
        }

        public setPaused(paused:boolean):void {
            this.isPaused = paused;
            if (this.isPaused) {
                this.scene.physics.pause();
                this.scene.anims.pauseAll();
                this.scene.tweens.pauseAll();
                this.scene.time.paused = true;
                this.inGameUI.pauseScreen.showPauseGame();
                nscs.sound.SoundManager.getInstance().fadeMusic(null, 500);
            } else {
                this.scene.physics.resume();
                this.scene.anims.resumeAll();
                this.scene.tweens.resumeAll();
                this.scene.time.paused = false;
                this.inGameUI.pauseScreen.hidePauseGame();
                nscs.sound.SoundManager.getInstance().revertMusic(500);
            }
        }

        public updateBG():void {
            let offx:number = this.player.sprite.x - 240;
            let offy:number = this.player.getFootsWorldY() - ((this.gameplay.gravityDir > 0) ? 181 : 135);
            if (offx<0) offx = 0;
            if (offx>this.gameplay.worldWidth-480) offx = this.gameplay.worldWidth-480;
            if (offy<0) offy = 0;
            if (offy>this.gameplay.worldHeight-320) offy = this.gameplay.worldHeight-320;
            this.bg.setPosition(-offx/5, -offy/5);
            this.fg.setPosition(-offx/2, -offy/2);
        }
    }
}
